import { useTranslation } from 'react-i18next';
import {
    useTheme,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    ResponsiveContainer,
    ChartTooltip,
} from '../../../../base';
import {
    IClientTimeToHireComparisonData,
    TIME_TO_HIRE_CHART_COLORS,
    getComparisonChartData,
    formatDurationTick,
} from '../../../../common';
import { Directions } from '../../../../common/consts/system.consts';
import ComparisonChartTooltip from './ComparisonChartTooltip';

interface IComparisonBarChartProps {
    data: IClientTimeToHireComparisonData;
}

const ComparisonBarChart = ({ data }: IComparisonBarChartProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isRtl = theme.direction === Directions.rtl;
    const chartData = getComparisonChartData(data, t);

    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart
                data={chartData}
                margin={{
                    top: 20,
                    right: isRtl ? 20 : 30,
                    left: isRtl ? 30 : 20,
                    bottom: 20,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis
                    dataKey="name"
                    reversed={isRtl}
                    tick={{
                        fill: theme.palette.text.secondary,
                        fontSize: 12,
                    }}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    domain={[0, 'auto']}
                    orientation={isRtl ? 'right' : 'left'}
                    tickFormatter={formatDurationTick}
                    tick={{
                        fill: theme.palette.text.secondary,
                        fontSize: 12,
                        textAnchor: 'end',
                    }}
                    axisLine={false}
                    tickLine={false}
                    width={80}
                />
                <ChartTooltip
                    content={ComparisonChartTooltip as never}
                    cursor={false}
                />
                {data.jobs.map((job, index) => (
                    <Bar
                        key={job.jobId}
                        dataKey={job.jobTitle}
                        fill={
                            TIME_TO_HIRE_CHART_COLORS[
                                index % TIME_TO_HIRE_CHART_COLORS.length
                            ]
                        }
                        barSize={24}
                        radius={[4, 4, 0, 0]}
                    />
                ))}
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ComparisonBarChart;
